import { BrandAssetUsage } from "@arrowsup/platform-dtos";

/** Joins ascending integers, collapsing contiguous runs: [1, 2, 4, 5, 6] → "1-2, 4-6". */
const formatRanges = (ascending: number[]): string => {
  const ranges: string[] = [];
  let start = 0;
  for (let i = 1; i <= ascending.length; i++) {
    if (i === ascending.length || ascending[i] !== ascending[i - 1] + 1) {
      const first = ascending[start];
      const last = ascending[i - 1];
      ranges.push(first === last ? `${first}` : `${first}-${last}`);
      start = i;
    }
  }
  return ranges.join(", ");
};

/** "Used by the draft and versions 1-2, 4", or undefined when unused. */
export const describeUsage = ({
  draft,
  versions,
}: BrandAssetUsage): string | undefined => {
  const uses: string[] = [];
  if (draft) {
    uses.push("the draft");
  }
  if (versions.length > 0) {
    const noun = versions.length === 1 ? "version" : "versions";
    uses.push(`${noun} ${formatRanges(versions)}`);
  }
  return uses.length > 0 ? `Used by ${uses.join(" and ")}` : undefined;
};
